import React, { useState } from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@roger/ui-components';

interface DeleteAttachmentButtonProps {
  onDelete: () => Promise<void>;
}

const DeleteAttachmentButton: React.FC<DeleteAttachmentButtonProps> = ({
  onDelete,
}) => {
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
      setOpen(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Popover
      open={open}
      onOpenChange={nextOpen => {
        if (!isDeleting) setOpen(nextOpen);
      }}
    >
      <PopoverTrigger asChild>
        <Button variant='ghost' size='sm'>
          <Trash2 className='h-4 w-4 text-destructive' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-3' align='end'>
        <div className='space-y-2'>
          <p className='text-sm font-medium'>Delete attachment?</p>
          <p className='text-xs text-muted-foreground'>
            This action cannot be undone.
          </p>
          <div className='flex justify-end gap-2'>
            <Button
              variant='outline'
              size='sm'
              onClick={() => setOpen(false)}
              disabled={isDeleting}
            >
              Cancel
            </Button>
            <Button
              variant='destructive'
              size='sm'
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting && <Loader2 className='h-4 w-4 mr-1 animate-spin' />}
              Delete
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DeleteAttachmentButton;
